import * as React from "react";
import Pagination from "@mui/material/Pagination";
import { useState, useEffect } from "react";
import { streamsLoad } from "../../appRedux/ducks/pastStreams";
import { connect } from "react-redux";

function PaginationComponent({
  videoKey,
  fetchStreams,
  total,
  customPageSize,
}) {
  const [page, setPage] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle screen resize to detect mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function handlePageChange(e, newPage) {
    setPage(newPage);
  }

  useEffect(() => {
    fetchStreams(videoKey, page, total, customPageSize);
  }, [page, videoKey]);

  const count = Math.ceil(total / customPageSize);

  // Mobile pagination props - show only 3 page numbers but keep first/last buttons
  const mobileProps = {
    boundaryCount: 0,
    siblingCount: 1,
    showFirstButton: true,
    showLastButton: true,
  };

  // Desktop pagination props - show more items
  const desktopProps = {
    boundaryCount: 3,
    siblingCount: 1,
    showFirstButton: true,
    showLastButton: true,
  };

  const paginationProps = isMobile ? mobileProps : desktopProps;

  return (
    <Pagination
      size="large"
      shape="circular"
      page={page}
      onChange={handlePageChange}
      count={count}
      {...paginationProps}
    />
  );
}
const stateToProps = (state) => ({
  pastStreams: state.streams.streams,
  loading: state.streams.loading,
  total: state.streams.total,
});
const dispatchToProps = (dispatch) => ({
  fetchStreams: (endpoint, page, total, per_page) =>
    dispatch(streamsLoad(endpoint, page, total, per_page)),
});
export default connect(stateToProps, dispatchToProps)(PaginationComponent);
